import { Button } from '@travelnest/merlin.button';
import theme from '@travelnest/merlin.theme';
import { startCase } from 'lodash';
import * as React from 'react';
import { currencySymbolForCurrencyString } from '../../helpers/currency_helpers';
import { DatePicker } from '../date-picker/DatePicker';
import { FormInput, FormLabel, FormRow, FormSelect } from '../form';
import { FormInputSymbol } from '../form/form-input-symbol/FormInputSymbol';
import { IPendingBookingReceipt } from './helpers';

interface IReceiptInputFormProps {
	defaultCurrency: string;
	defaultAmount: number;
	paymentMethods: string[] | Record<string, string>;
	currencies?: string[];
	lockCurrency?: boolean;
	receipt: IPendingBookingReceipt;
	setReceipt: (receipt: IPendingBookingReceipt) => any;
	submitReceipt: (receipt: IPendingBookingReceipt) => any;
}

const baseCurrencies = ['GBP', 'EUR', 'USD'];

const normalisePaymentMethods = (methods: string[] | Record<string, string>): Record<string, string> => {
	if (Array.isArray(methods)) {
		return methods.reduce<Record<string, string>>((prev: object, cur) => ({ ...prev, [cur]: cur }), {});
	}

	return methods;
};

export const ReceiptInputForm: React.FC<IReceiptInputFormProps> = (props) => {
	const currencies = props.currencies ? props.currencies : baseCurrencies;
	const normalisedPaymentMethods = normalisePaymentMethods(props.paymentMethods);

	return <div className="booking-payment__data-entry">
		<FormRow>
			<section className="booking-payment__input-flex">
				<div>
					<FormLabel htmlFor="booking_receipt_date">Date</FormLabel>
					<DatePicker
						value={props.receipt.date}
						onChange={(date) => props.setReceipt({ ...props.receipt, date: new Date(date) })}
					/>
				</div>
				<div>
					<FormLabel htmlFor="booking_receipt_method">Method</FormLabel>
					<FormSelect
						value={props.receipt.method || ''}
						onChange={(e) => props.setReceipt({ ...props.receipt, method: e.target.value })}
					>
						{Object.entries(normalisedPaymentMethods).map(([key, value]) => <option key={key} value={value}>{startCase(key)}</option>)}
					</FormSelect>
				</div>
			</section>
		</FormRow>
		<FormRow>
			<section className="booking-payment__input-flex">
				<div>
					<FormLabel htmlFor="booking_receipt_currency">Currency</FormLabel>
					<FormSelect
						disabled={props.lockCurrency}
						onChange={(e) => props.setReceipt({ ...props.receipt, currency: e.target.value })}
						value={props.receipt.currency}>
						{currencies.map((c: string) => <option key={c} value={c}>{`${c} (${currencySymbolForCurrencyString(c)})`}</option>)}
					</FormSelect>
				</div>
				<div>
					<FormLabel htmlFor="booking_receipt_value">Value</FormLabel>
					<FormInputSymbol
						symbol={currencySymbolForCurrencyString(props.receipt.currency)}
						value={props.receipt.amount}
						onChange={(e) => props.setReceipt({ ...props.receipt, amount: Number(e.target.value) })}
					/>
				</div>
			</section>
		</FormRow>
		<FormRow>
			<FormLabel htmlFor="booking_receipt_reference">Comment</FormLabel>
			<FormInput
				widthtype="wide"
				value={props.receipt.reference || ''}
				onChange={(e) => props.setReceipt({ ...props.receipt, reference: e.target.value })}
			/>
		</FormRow>
		<div className="booking-payment__data-entry--button">
			<Button
				bgColor={theme.colours.neutral.darker}
				color={theme.colours.text.lightest}
				hoverColor={theme.colours.neutral.dark}
				onClick={(e) => props.submitReceipt(props.receipt)}>Submit</Button>
		</div>
	</div>;
};
